import React from "react";

const TermsOfUse = ({ isTamil }) => {
  return (
    <div className="terms-container" style={{ padding: '100px 20px', maxWidth: '1000px', margin: '0 auto', lineHeight: '1.8' }}>
      <h1 style={{ textAlign: 'center', color: '#0f3d2e', marginBottom: '40px' }}>
        {isTamil ? "நிபந்தனைகள் மற்றும் விதிமுறைகள்" : "Terms and Conditions"}
      </h1>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2e7d32' }}>Introduction and Core Mission</h2>
        <p>
          Welcome to the official platform of the Tamilmanamalai Charitable Trust. By accessing and using this website, 
          you agree to abide by the terms and conditions outlined herein. Our organization is a dedicated social welfare 
          entity established to serve the underprivileged sections of society. Our primary mission is to facilitate marriage 
          assistance for those in need, provide essential support to destitute elderly individuals, and enhance educational, 
          cultural, and social services for students who have lost their parents.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2e7d32' }}>Matrimony and Marriage Support Services</h2>
        <p>
          As a matrimony trust website, we offer specialized registration services to help families find suitable matches. 
          Users must provide accurate, truthful, and verifiable information during the registration process. We utilize an 
          automatic ID generation system to maintain an organized and efficient database for our beneficiaries. 
          Marriage support is strictly intended for individuals who meet the legal marriageable age requirements in India 
          and can demonstrate a genuine financial need through valid documentation.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2e7d32' }}>Medical Assistance and Welfare Programs</h2>
        <p>
          Tamilmanamalai Charitable Trust is deeply committed to providing medical support to those facing health crises 
          without financial means. Requests for medical aid are evaluated based on the urgency of the condition and 
          the availability of trust funds. Applicants are required to submit authentic hospital records and prescriptions 
          for verification. The Trust reserves the right to disburse funds directly to medical institutions to ensure transparency.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2e7d32' }}>Donations and Legal Status</h2>
        <p>
          Financial contributions made through our portal are used exclusively for welfare projects. Currently, our 
          12AB registration is active. However, please be advised that our 80G certification is currently 
          <strong> under process</strong>. We appreciate your continued patience and support.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ color: '#2e7d32' }}>User Conduct and Privacy</h2>
        <p>
          All personal data collected for matrimony or medical assistance is handled with strict confidentiality. 
          Users are prohibited from using any data found on this website for commercial marketing or spamming. 
          While the Trust makes every effort to verify profiles, we act as facilitators and are not liable for the 
          outcomes of personal relationships or medical treatments.
        </p>
      </section>
    </div>
  );
};

export default TermsOfUse;